package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_26_Day_4() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes walk North to Lake Drolida, and Korvis casts breath underwater. Tuesday explains the situation to Flower and Aloysius. The heroes dive into the dark waters. Korvis finds a depression in the lake bed that looks like a collapsed tunnel. Bigglesworth digs with his hands and sword, and Annette builds and operates a drill, but the soft sand just fills back in. The heroes spot some Chuul tracks underwater leading southwest toward another lake.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes walk toward the other lake.")
    }
}
